import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import for navigation
import './CourseCard.css'; // Import the standard CSS file for CourseCard

export function CourseCard({ 
  imageUrl, 
  courseCode, 
  courseName, 
  instructorName, 
  courseId, 
  onClick 
}) {
  const navigate = useNavigate(); // Initialize the navigate function

  // Handle click event: navigate or trigger onClick callback if provided
  const handleClick = () => {
    if (onClick) {
      onClick(); // Trigger the custom onClick callback
    } else if (courseId) {
      navigate(`/course/${courseId}`); // Navigate to course details page
    }
  };

  return (
    <article className="courseCard" onClick={handleClick}> {/* Make the whole card clickable */}
      <img 
        src={imageUrl} 
        alt={courseCode} 
        className="courseImage" 
        loading="eager" 
      />
      <h3 className="courseTitle">{courseCode}</h3>
      <h3 className="courseName">{courseName}</h3>
      <p className="instructorName">Instructor: {instructorName}</p>
    </article>
  );
}
